import Papa from "papaparse";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../locale";
import ProductService from "../../../../service/ProductService";
import { uploadImages } from "../../../../utilities/uploadImages/uploadImages";
import "../StatementTable/StatementTable.css";
import "../UserDashboardHome/UserDashboardHome.css";
import aliexpressLogo from "../../../images/importproducts/aliexpress.png";
import amazonLogo from "../../../images/importproducts/amazon.png";
import magentoLogo from "../../../images/importproducts/magento.png";
import prestashopLogo from "../../../images/importproducts/prestashop.png";
import shopifyLogo from "../../../images/importproducts/shopify.png";
import woocommerceLogo from "../../../images/importproducts/woocommerce.png";
import { useHistory } from "react-router-dom";

const ImportProducts = ({ plan }) => {
  const { showErrorToast } = useToastContext();
  const history = useHistory();

  const fileUploadRef = useRef(null);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importOrigin, setImportOrigin] = useState("SHOPIFY");
  const [woocommercePremiumCSV, setWoocommercePremiumCSV] = useState(false);
  const [isItalian, setIsItalian] = useState(false);

  function handleCSV(file) {
    if (file.size / 1024 / 1024 > 2) {
      fileUploadRef.current.clear();
      showErrorToast({ detail: "fileSizeTooBig" });
      return false;
    }

    Papa.parse(file, {
      header: true,
      complete: function (results) {
        setProducts(results.data);
        if (results.data[0]["post_title"]) {
          setWoocommercePremiumCSV(true);
          setIsItalian(false);
        } else if (results.data[0]["Nome"]) {
          setIsItalian(true);
          setWoocommercePremiumCSV(false);
        }
      },
    });
  }

  const filters2 = {
    Title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    post_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    item_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  async function uploadProductImages(product, imageField, fileName) {
    try {
      const imageBlob = await (
        await fetch(product[imageField].split(woocommercePremiumCSV ? " " : ", ")[0])
      ).blob();
      const imageFile = new File([imageBlob], fileName, { type: imageBlob.type });

      const imageid = await uploadImages(imageFile, toast, productService);
      return imageid;
    } catch {
      const imageBlob = await (
        await fetch(
          "https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc="
        )
      ).blob();
      const imageFile = new File([imageBlob], fileName, { type: imageBlob.type });

      const imageid = await uploadImages(imageFile, toast, productService);
      return imageid;
    }
  }

  async function setImportFields(origin, product) {
    switch (origin) {
      case "SHOPIFY":
        const imageidShopify = await uploadProductImages(product, "Image Src", "shopifyimage");

        return {
          title: product["Title"],
          description: product["Body (HTML)"],
          priceUnique: parseFloat(product["Variant Price"]),
          productState: product["Google Shopping / Condition"] === "used" ? "USED" : "NEW",
          imageid1: imageidShopify,
          percentExtraCoin: 50,
          productStatus: "UNPUBLISHED",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          height: 10,
          width: 10,
          length: 10,
          weight: 10,
          originProductImported: "SHOPIFY",
          sendBy: "SELLER",
          promotionalPriceUnique: null,
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      case "MAGENTO":
        const imageidMagento = await uploadProductImages(product, "base_image", "magentoimage");

        return {
          title: product["name"],
          description: product["description"],
          priceUnique: parseFloat(product["price"]),
          promotionalPriceUnique: parseFloat(product["special_price"]) ?? null,
          weight: parseFloat(product["weight"]),
          imageid1: imageidMagento,
          percentExtraCoin: 50,
          productState: "NEW",
          productStatus: "UNPUBLISHED",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          height: 10,
          width: 10,
          length: 10,
          originProductImported: "MAGENTO",
          sendBy: "SELLER",
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      case "PRESTASHOP":
        const imageidPrestaShop = await uploadProductImages(product, "id_image", "prestashopimage");

        return {
          title: product["name"],
          description: product["description"],
          priceUnique: parseFloat(product["price"]),
          weight: parseFloat(product["weight"]),
          imageid1: imageidPrestaShop,
          percentExtraCoin: 50,
          productState: product["condition"] === "used" ? "USED" : "NEW",
          productStatus: "UNPUBLISHED",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          height: 10,
          width: 10,
          length: 10,
          originProductImported: "PRESTASHOP",
          sendBy: "SELLER",
          promotionalPriceUnique: null,
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      case "WOOCOMMERCE":
        const imageidWoocommerce = await uploadProductImages(
          product,
          woocommercePremiumCSV ? "images" : isItalian ? "Immagine" : "Images",
          "woocommerceImage"
        );

        return {
          title: product[woocommercePremiumCSV ? "post_title" : isItalian ? "Nome" : "Name"],
          description:
            product[
              woocommercePremiumCSV ? "post_content" : isItalian ? "Descrizione" : "Description"
            ],
          priceUnique: parseFloat(
            product[
              woocommercePremiumCSV
                ? "regular_price"
                : isItalian
                ? "Prezzo di listino"
                : "Regular price"
            ]
          ),
          promotionalPriceUnique: parseFloat(
            product[
              woocommercePremiumCSV ? "sale_price" : isItalian ? "Prezzo in offerta" : "Sale price"
            ]
          ),
          imageid1: imageidWoocommerce,
          percentExtraCoin: 50,
          productStatus: "UNPUBLISHED",
          productState: "NEW",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          height: parseFloat(
            product[woocommercePremiumCSV ? "height" : isItalian ? "Altezza (cm)" : "Height (in)"]
          )
            ? parseFloat(
                product[
                  woocommercePremiumCSV ? "height" : isItalian ? "Altezza (cm)" : "Height (in)"
                ]
              )
            : 10,
          width: parseFloat(product[woocommercePremiumCSV ? "width" : "Width (in)"])
            ? parseFloat(product[woocommercePremiumCSV ? "width" : "Width (in)"])
            : 10,
          length: parseFloat(
            product[woocommercePremiumCSV ? "length" : isItalian ? "Lunghezza (cm)" : "Length (in)"]
          )
            ? parseFloat(
                product[
                  woocommercePremiumCSV ? "length" : isItalian ? "Lunghezza (cm)" : "Length (in)"
                ]
              )
            : 10,
          weight: parseFloat(
            product[woocommercePremiumCSV ? "weight" : isItalian ? "Peso (kg)" : "Weight (lbs)"]
          )
            ? parseFloat(
                product[woocommercePremiumCSV ? "weight" : isItalian ? "Peso (kg)" : "Weight (lbs)"]
              )
            : 10,
          originProductImported: "WOOCOMMERCE",
          sendBy: "SELLER",
          imported: true,
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      case "AMAZON":
        const imageidAmazon = await uploadProductImages(product, "main_image_url", "amazonimage");

        return {
          title: product["item_name"],
          priceUnique: parseFloat(product["standard_price"]),
          imageid1: imageidAmazon,
          height: product["item_height"],
          width: product["item_width"],
          length: product["item_length"],
          weight: product["item_weight"],
          percentExtraCoin: 50,
          productStatus: "UNPUBLISHED",
          productState: "NEW",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          originProductImported: "AMAZON",
          sendBy: "SELLER",
          description: "",
          promotionalPriceUnique: null,
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      case "ALIEXPRESS":
        const imageidAliexpress = await uploadProductImages(
          product,
          "Image url",
          "aliexpressImage"
        );

        return {
          title: product["Product Title"],
          priceUnique: parseFloat(product["Min Price"]),
          imageid1: imageidAliexpress,
          percentExtraCoin: 50,
          productStatus: "UNPUBLISHED",
          productState: "NEW",
          subCategory: { id: 6 },
          user: { username: localStorage.getItem("__extraconomy_username") },
          originProductImported: "ALIEXPRESS",
          sendBy: "SELLER",
          description: "",
          height: 10,
          width: 10,
          length: 10,
          weight: 10,
          promotionalPriceUnique: null,
          model: null,
          brand: null,
          type: null,
          genderProduct: null,
          downloadable: false,
          downloadtype: null,
          urldownload: null,
          urldownloadsample: null,
          cdnType: null,
          downloadType: null,
        };
      default:
        break;
    }
  }

  const productService = new ProductService();

  async function confirmImport() {
    try {
      setLoading(true);

      for (const product of products) {
        const productObj = await setImportFields(importOrigin, product);
        const res = await productService.postRegisterProduct(
          localStorage.getItem("__extraconomy_token"),
          productObj
        );

        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode, message: res.message });
          setLoading(false);
          if (res.messageCode === 500000) console.log(res);
          return false;
        }
      }

      setLoading(false);
      history.push("/products?imported=true");
    } catch (e) {
      console.log(e);
    }
  }

  const toast = useRef(null);

  function columnFields() {
    switch (importOrigin) {
      case "SHOPIFY":
        return {
          title: "Title",
          image: "Image Src",
          price: "Price / International",
        };
      case "MAGENTO":
        return {
          title: "name",
          image: "base_image",
          price: "price",
        };
      case "PRESTASHOP":
        return {
          title: "name",
          image: "id_image",
          price: "price",
        };
      case "WOOCOMMERCE":
        return {
          title: woocommercePremiumCSV ? "post_title" : isItalian ? "Nome" : "Name",
          image: woocommercePremiumCSV ? "images" : isItalian ? "Immagine" : "Images",
          price: woocommercePremiumCSV
            ? "regular_price"
            : isItalian
            ? "Prezzo di listino"
            : "Regular price",
        };
      case "ALIEXPRESS":
        return {
          title: "Product Title",
          image: "Image url",
          price: "Min Price",
        };
      case "AMAZON":
        return {
          title: "item_name",
          image: "main_image_url",
          price: "standard_price",
        };
      default:
        return { title: "", image: "", price: "" };
    }
  }

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      {plan === "Manager" || plan === "Seller" ? (
        <>
          <h3 className="my-4">{localeText("importProducts")}</h3>
          <hr />

          {products.length > 0 ? (
            <>
              <DataTable
                className="mt-4 mb-6 p-datatable-customers"
                value={products}
                paginator
                loading={loading}
                filters={filters2}
                filterDisplay="row"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate={localeText("showingFirstToLast")}
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
              >
                <Column
                  header={localeText("productImage")}
                  body={(product) => {
                    return (
                      <img
                        src={
                          product[columnFields()["image"]]
                            ? product[columnFields()["image"]].split(
                                woocommercePremiumCSV ? " " : ", "
                              )[0]
                            : ""
                        }
                        alt={product["Image Alt Text"]}
                        height={75}
                        width={75}
                      ></img>
                    );
                  }}
                />
                <Column
                  field={columnFields()["title"]}
                  header={localeText("title")}
                  filter
                  filterPlaceholder={localeText("searchByTitle")}
                  filters={filters2}
                  filterDisplay="row"
                />
                <Column field={columnFields()["price"]} header={localeText("price")} sortable />
              </DataTable>

              <div className="flex align-items-center">
                <i className="pi pi-exclamation-triangle text-2xl"></i>
                <h4 className="m-0 ml-2">{localeText("attention")}</h4>
              </div>
              <p className="text-lg my-4">{localeText("importTemplateExplanation")}</p>
              <Button
                className="mb-6"
                onClick={() => confirmImport()}
                label={localeText("confirm")}
                loading={loading}
              />
            </>
          ) : (
            <>
              <div className="flex flex-wrap gap-3">
                <div className="flex align-items-center">
                  <div className="flex align-items-center">
                    <RadioButton
                      value={"ALIEXPRESS"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "ALIEXPRESS"}
                    />
                    <img
                      className="ml-2"
                      src={aliexpressLogo}
                      height={32}
                      alt="aliexpress logo"
                    ></img>
                    <label className="ml-2">AliExpress</label>
                  </div>

                  <div className="flex align-items-center ml-4">
                    <RadioButton
                      value={"AMAZON"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "AMAZON"}
                    />
                    <img className="ml-2" src={amazonLogo} alt="amazon logo"></img>
                    <label className="ml-2">Amazon</label>
                  </div>

                  <div className="flex align-items-center ml-4">
                    <RadioButton
                      value={"MAGENTO"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "MAGENTO"}
                    />
                    <img className="ml-2" src={magentoLogo} height={32} alt="magento logo"></img>
                    <label className="ml-2">Magento 2</label>
                  </div>

                  <div className="flex align-items-center ml-4">
                    <RadioButton
                      value={"PRESTASHOP"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "PRESTASHOP"}
                    />
                    <img
                      className="ml-2"
                      src={prestashopLogo}
                      height={32}
                      alt="prestashop logo"
                    ></img>
                    <label className="ml-2">PrestaShop</label>
                  </div>

                  <div className="flex align-items-center ml-4">
                    <RadioButton
                      value={"SHOPIFY"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "SHOPIFY"}
                    />
                    <img className="ml-2" src={shopifyLogo} alt="shopify logo"></img>
                    <label className="ml-2">Shopify</label>
                  </div>

                  <div className="flex align-items-center ml-4">
                    <RadioButton
                      value={"WOOCOMMERCE"}
                      onChange={(e) => setImportOrigin(e.value)}
                      checked={importOrigin === "WOOCOMMERCE"}
                    />
                    <img
                      className="ml-2"
                      src={woocommerceLogo}
                      height={32}
                      alt="woocommerce logo"
                    ></img>
                    <label className="ml-2">WooCommerce</label>
                  </div>
                </div>
              </div>
              <p htmlFor="csvUpload" className="mt-4">
                {localeText("importProductsFromCSVFile")}
              </p>
              <FileUpload
                className="mb-4"
                mode="basic"
                name="csvUpload"
                accept="text/csv"
                onSelect={(e) => handleCSV(e.files[0])}
                ref={fileUploadRef}
              />
            </>
          )}
        </>
      ) : (
        <div className="text-center">
          <i className="pi pi-lock text-8xl text-400 my-4"></i>
          <h2 className="my-6">{localeText("planNotAllowed")}</h2>
        </div>
      )}
    </div>
  );
};

export default ImportProducts;

